var storefrontApp = angular.module("storefrontApp");
storefrontApp.service('testimonialService', ['$http', function ($http) {
    return {
        getTestimonials: function () {
            return $http.get('storefrontapi/learningcenter/gettestimonials');
        },
        insertTestimonial: function (form_data) {
            return $http.post('storefrontapi/learningcenter/inserttestimonial',
                form_data,
                {
                    headers: { "Content-Type": undefined },
                });
        }
    }
}]);
